import React from "react"
import BiggestBox from './BiggestBox';
import { QueryClient, QueryClientProvider } from 'react-query'
import isUUID from 'validator/lib/isUUID';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

function SortIt() {
  let getParams = new URLSearchParams(window.location.search)
  if (!getParams.has("uuid") || !isUUID(getParams.get("uuid")))
    return (
      <div>Please provide a valid UUID.</div>
    )
  return (
    <QueryClientProvider client={queryClient}>
      <BiggestBox uuid={getParams.get("uuid")} />
    </QueryClientProvider >
  )
}

export default SortIt;